/*
 * @Author: Chao Yang
 * @Date: 2019-09-24 06:42:55
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-08-13 00:55:17
 */
import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { HeaderOption, HeaderMenuItem } from '../model';

@Component({
  selector: 'ad-section-header-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
})
export class DefaultComponent implements OnInit {
  menus: HeaderMenuItem[] = [];
  name = '';
  options: HeaderOption;
  @Input() logoUrl = '';
  _branding = "";
  @Input() set branding(val: string) {
    if (val) {
      this._branding = val.toLowerCase();
    }
  }

  get branding() {
    return this._branding;
  }
  @Input() set option(val: HeaderOption) {
    if (!this.checkObjectIsDefined(val)) {
      return;
    }
    this.options = val;

    this.name = this.options.user.name;
    this.menus = this.options.user.menus;
  }

  @Input() rightToolTemplate: TemplateRef<any>;

  constructor() { }

  checkLogoLinkIsExisted(): boolean {
    return (
      this.checkObjectIsDefined(this.options) &&
      this.checkObjectIsDefined(this.options.logo) &&
      this.checkStringIsDefinfed(this.options.logo.link)
    );
  }

  checkObjectIsDefined(obj: any): boolean {
    if (obj === undefined || obj === null) {
      return false;
    }
    return true;
  }

  checkStringIsDefinfed(str: string): boolean {
    return this.checkObjectIsDefined(str) && str !== '';
  }

  clickLogo(e: Event): void {
    e.preventDefault();
    e.stopPropagation();
    if (this.checkLogoLinkIsExisted()) {
      location.href = this.options.logo.link;
    }
  }

  clickMenu(e: Event, menu: HeaderMenuItem): void {
    e.preventDefault();
    e.stopPropagation();
    if (menu.target === '_blank') {
      window.open(menu.link, menu.target);
    } else {
      location.href = menu.link;
    }
  }

  ngOnInit(): void { }

  viewAllPortfolios(e: Event): void {
    location.href =
      '/transferstation/investorportal/all?returnUrl=' +
      encodeURIComponent(location.href);
  }
}
